<app-dashboard-option [categories]="['CELLS']" [label]="'ADD'">
  <div app-dashboard-option-content>
    <button mdbBtn (click)="onAdd()" type="button" color="light" size="sm" class="px-2 z-depth-0 m-0" mdbWavesEffect>
      <i class="fas fa-plus fa-fw {{ color }}-text"></i>
    </button>
  </div>
</app-dashboard-option>